import TenantSwitchWarning from './tenant_switch_warning';

export default TenantSwitchWarning;
